import { Component, OnInit, Input, HostListener, DoCheck, ElementRef, Renderer2 } from '@angular/core';
import { TableHandler, Col, Row } from '../../../../../../../classes';
import { numberToAlphabet } from './number-to-alphabet.fn';

@Component({
  selector: '[helper-cell]',
  templateUrl: './helper-cell.component.html',
  styleUrls: ['./helper-cell.component.scss']
})
export class HelperCellComponent implements OnInit, DoCheck  {
  @Input() table:TableHandler;
  @Input() col:Col;
  @Input() row:Row;
  get isFirst ():boolean {
    if (this.col) return this.col.priority === 0
    else if (this.row) return this.row.priority === 0
  }
  get value () {
    if (this.col) return numberToAlphabet(this.col.priority + (this.table.showYHeader ? 0 : 1));
    else if (this.row) return this.row.priority + ( this.table.showXHeader ? 0 : 1) + 1;
  }
  constructor(
    private elementRef:ElementRef,
    private renderer:Renderer2,
    
  ) {
  }

  ngOnInit() {
    this.renderer.addClass(this.elementRef.nativeElement, 'noselect');
    this.renderer.addClass(this.elementRef.nativeElement, 'cursor-pointer');
    this.renderer.addClass(this.elementRef.nativeElement, 'position-relative');
    if (this.row) this.renderer.addClass(this.elementRef.nativeElement, 'p-2');
  }
  ngDoCheck () {
    if (this.col) {
      if (this.table.focus.colId === this.col.id && this.table.focus.rowId === undefined) {
        this.renderer.addClass(this.elementRef.nativeElement, 'focus');
      } else {
        this.renderer.removeClass(this.elementRef.nativeElement, 'focus');
      }
    } 
    else if (this.row) {
      if (this.table.focus.colId === undefined && this.table.focus.rowId === this.row.id) {
        this.renderer.addClass(this.elementRef.nativeElement, 'focus');
      } else {
        this.renderer.removeClass(this.elementRef.nativeElement, 'focus');
      }
    }
  }
  @HostListener('click', []) toggleFocus (bool:boolean = undefined) {
    if (this.col) this.table.toggleFocus(this.col.id, undefined, bool);
    else if (this.row) this.table.toggleFocus(undefined, this.row.id, bool);
  }
  remove () {
    if (this.col) this.table.removeColumn(this.col)
    else if (this.row) this.table.removeRow(this.row)
  }
  addBefore () {
    if (this.col) this.table.addColumn(this.col.priority)
    else if (this.row) this.table.addRow(this.row.priority)
  }
  addAfter () {
    if (this.col) this.table.addColumn(this.col.priority + 1)
    else if (this.row) this.table.addRow(this.row.priority + 1)
  }

}
